import ReactRailsUJS from 'react_ujs'
import { setReactConstructor } from '../helpers/ViteHelper'
import baseFrontModules from '../helpers/entrypoint_modules/baseFront'

const modules = import.meta.glob([
  '~/components/cms/docs/webinars/DocsWebinars.{js,jsx,ts,tsx}',
], { eager: true })

const mergedModules = Object.assign(modules, baseFrontModules)

setReactConstructor(ReactRailsUJS, mergedModules)
